(() => {
  'use strict';
  const page = document.querySelector('[data-pm-page]');
  if (!page || page.dataset.pmReady === 'true') return;
  page.dataset.pmReady = 'true';
  const all = (selector) => [...page.querySelectorAll(selector)];
  const variants = JSON.parse(page.querySelector('[data-pm-variants-json]').textContent);
  const findVariant = (id) => variants.find((variant) => String(variant.id) === String(id));
  const url = new URL(window.location.href);
  let selected = findVariant(url.searchParams.get('variant')) || findVariant(page.dataset.pmDefault) || variants[0];
  let quantity = Math.max(1, Number(selected.minimum) || 1);
  let pending = false;
  let circuitOpen = false;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const textOnly = (value) => {
    const holder = document.createElement('div');
    holder.innerHTML = value || '';
    return holder.textContent || '';
  };
  const normalizedQuantity = (value) => {
    const minimum = Math.max(1, Number(selected.minimum) || 1);
    const increment = Math.max(1, Number(selected.increment) || 1);
    const maximum = selected.maximum == null ? Infinity : Math.max(minimum, Number(selected.maximum));
    const numeric = Number.isFinite(Number(value)) ? Number(value) : minimum;
    const safe = Math.min(maximum, Math.max(minimum, numeric));
    return minimum + Math.floor((safe - minimum) / increment) * increment;
  };
  const clearMessages = () => {
    if (circuitOpen) return;
    all('[data-pm-message]').forEach((node) => { node.hidden = true; node.textContent = ''; node.classList.remove('is-error'); });
    all('[data-pm-cart-link]').forEach((node) => { node.hidden = true; });
  };
  const showMessage = (message, error, showCart = false) => {
    all('[data-pm-message]').forEach((node) => { node.textContent = message; node.hidden = false; node.classList.toggle('is-error', Boolean(error)); });
    all('[data-pm-cart-link]').forEach((node) => { node.hidden = !showCart; });
  };
  const updateControls = () => {
    all('[data-pm-variant]').forEach((input) => { input.checked = String(input.value) === String(selected.id); input.disabled = pending; });
    all('[data-pm-variant-id]').forEach((input) => { input.value = selected.id; });
    all('[data-pm-quantity]').forEach((input) => {
      input.value = quantity;
      input.min = selected.minimum || 1;
      input.step = selected.increment || 1;
      if (selected.maximum == null) input.removeAttribute('max'); else input.max = selected.maximum;
      input.disabled = pending;
    });
    all('[data-pm-quantity-step]').forEach((button) => {
      const direction = Number(button.dataset.pmQuantityStep);
      const next = normalizedQuantity(quantity + direction * (selected.increment || 1));
      button.disabled = pending || next === quantity;
    });
    all('[data-pm-price]').forEach((node) => { node.textContent = textOnly(selected.priceText); });
    all('[data-pm-compare]').forEach((node) => { node.hidden = !(Number(selected.compareAt) > Number(selected.price)); node.textContent = textOnly(selected.compareText); });
    all('[data-pm-availability]').forEach((node) => { node.textContent = selected.available ? 'Available' : 'Sold out'; });
    all('[data-pm-add]').forEach((button) => { button.disabled = pending || circuitOpen || !selected.available; button.textContent = pending ? 'Adding…' : (selected.available ? 'Add to cart' : 'Sold out'); });
    all('[data-pm-buy]').forEach((button) => { button.disabled = pending || circuitOpen || !selected.available; button.textContent = pending ? 'Please wait…' : 'Buy now'; });
    all('[data-pm-form]').forEach((form) => { form.setAttribute('aria-busy', String(pending)); });
    all('[data-pm-sticky-title]').forEach((node) => { node.textContent = selected.title + ' lens'; });
    all('[data-pm-model-note]').forEach((node) => { node.textContent = String(selected.id) === '52179914752321' ? '100X model shown in the demonstrations below.' : '200X selected. The demonstrations and fit measurements below describe the 100X model.'; });
    const rules = [];
    if (Number(selected.minimum) > 1) rules.push('Minimum ' + selected.minimum);
    if (Number(selected.increment) > 1) rules.push('Increments of ' + selected.increment);
    if (selected.maximum != null) rules.push('Maximum ' + selected.maximum);
    all('[data-pm-quantity-rule]').forEach((node) => { node.hidden = !rules.length; node.textContent = rules.join(' · '); });
  };
  const updateHero = () => {
    const hero = page.querySelector('[data-pm-hero-image]');
    const source = String(selected.id) === '52179914752321' ? page.dataset.pmHeroDefault : (selected.image || page.dataset.pmHeroDefault);
    if (hero.getAttribute('src') !== source) hero.src = source;
    hero.alt = selected.title + ' clip-on smartphone microscope lens';
    page.querySelector('[data-pm-image-label]').textContent = selected.title + ' lens';
  };
  const chooseVariant = (id, updateUrl = true) => {
    const variant = findVariant(id);
    if (!variant || pending) return;
    selected = variant;
    quantity = normalizedQuantity(quantity);
    clearMessages();
    updateControls();
    updateHero();
    if (updateUrl) {
      const next = new URL(window.location.href);
      next.searchParams.set('variant', selected.id);
      window.history.replaceState(window.history.state, '', next.toString());
    }
  };
  const stopCircuit = (message) => {
    circuitOpen = true;
    showMessage(message, true, true);
  };
  const addToCart = async (checkout) => {
    if (pending || circuitOpen || !selected.available) return;
    quantity = normalizedQuantity(quantity);
    const requestVariant = selected;
    const requestQuantity = quantity;
    pending = true;
    clearMessages();
    updateControls();
    let response;
    let raw;
    let navigating = false;
    try {
      // Horizon renders its cart drawer from sections returned by this same add request.
      const cartSections = [...new Set(
        [...document.querySelectorAll('cart-items-component[data-section-id]')]
          .map((component) => component.dataset.sectionId).filter(Boolean)
      )].slice(0, 5);
      const requestBody = { items: [{ id: requestVariant.id, quantity: requestQuantity }] };
      if (cartSections.length) {
        requestBody.sections = cartSections.join(',');
        requestBody.sections_url = window.location.pathname + window.location.search;
      }
      response = await fetch(page.dataset.pmCartAdd, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(requestBody)
      });
      raw = await response.text();
    } catch (_) {
      stopCircuit('We could not confirm the cart update. Open your cart to check before adding again.');
      pending = false;
      updateControls();
      return;
    }
    try {
      const limited = response.status === 429 || response.status === 503 || /local_rate_limited/i.test(raw);
      if (limited) {
        stopCircuit('The store is temporarily unable to update your cart. Please check your cart and try again later.');
        return;
      }
      let data;
      try { data = JSON.parse(raw); } catch (_) {
        stopCircuit('We could not confirm the cart update. Open your cart to check before adding again.');
        return;
      }
      if (!response.ok) {
        if (response.status >= 500) {
          stopCircuit('We could not confirm the cart update. Open your cart to check before adding again.');
          return;
        }
        showMessage(typeof data.description === 'string' ? data.description : 'This selection could not be added. Check the option and quantity, then try again.', true);
        return;
      }
      const added = Array.isArray(data.items) ? data.items : [data];
      if (!added.some((item) => String(item.variant_id || item.id) === String(requestVariant.id))) {
        stopCircuit('We could not confirm your selected option. Open your cart to check before adding again.');
        return;
      }
      // Match Horizon's CartAddEvent contract: itemCount is the quantity just added.
      page.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          sourceId: String(requestVariant.id),
          data: {
            source: 'product-form-component',
            productId: '10364853223745',
            variantId: String(requestVariant.id),
            itemCount: requestQuantity,
            sections: data.sections || {}
          }
        }
      }));
      showMessage(requestQuantity + ' × ' + requestVariant.title + ' added to your cart.', false, true);
      if (checkout) {
        const root = (page.dataset.pmRoot || '/').replace(/\/?$/, '/');
        navigating = true;
        window.location.assign(root + 'checkout');
      }
    } finally {
      if (!navigating) pending = false;
      updateControls();
    }
  };
  all('[data-pm-variant]').forEach((input) => input.addEventListener('change', () => chooseVariant(input.value)));
  all('[data-pm-quantity]').forEach((input) => {
    input.addEventListener('input', () => {
      if (input.value !== '' && Number.isFinite(Number(input.value))) {
        quantity = normalizedQuantity(input.value);
        all('[data-pm-quantity]').filter((other) => other !== input).forEach((other) => { other.value = quantity; });
      }
    });
    input.addEventListener('change', () => { quantity = normalizedQuantity(input.value); clearMessages(); updateControls(); });
  });
  all('[data-pm-quantity-step]').forEach((button) => button.addEventListener('click', () => {
    if (pending) return;
    quantity = normalizedQuantity(quantity + Number(button.dataset.pmQuantityStep) * (selected.increment || 1));
    clearMessages(); updateControls();
  }));
  all('[data-pm-form]').forEach((form) => form.addEventListener('submit', (event) => { event.preventDefault(); addToCart(false); }));
  all('[data-pm-buy]').forEach((button) => button.addEventListener('click', () => addToCart(true)));
  window.addEventListener('popstate', () => {
    const nextId = new URL(window.location.href).searchParams.get('variant') || page.dataset.pmDefault;
    chooseVariant(nextId, false);
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && !circuitOpen) { pending = false; updateControls(); }
  });
  all('[data-pm-jump]').forEach((anchor) => anchor.addEventListener('click', (event) => {
    const target = page.querySelector(anchor.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
  }));
  const sticky = page.querySelector('[data-pm-sticky]');
  const firstPurchase = page.querySelector('#pm-purchase-first');
  const secondPurchase = page.querySelector('#pm-purchase-second');
  const finalPurchase = page.querySelector('[data-pm-final]');
  let scheduled = false;
  const refreshSticky = () => {
    scheduled = false;
    const first = firstPurchase.getBoundingClientRect();
    const second = secondPurchase.getBoundingClientRect();
    const final = finalPurchase.getBoundingClientRect();
    const visible = (rect) => rect.top < window.innerHeight && rect.bottom > 0;
    sticky.hidden = !(first.bottom < 0 && !visible(second) && !visible(final));
  };
  const queueSticky = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(refreshSticky); } };
  window.addEventListener('scroll', queueSticky, { passive: true });
  window.addEventListener('resize', queueSticky, { passive: true });
  const video = page.querySelector('[data-pm-video]');
  const videoButton = page.querySelector('[data-pm-video-toggle]');
  let videoInView = false;
  let userPaused = false;
  const loadVideo = () => { if (!video.getAttribute('src')) { video.src = video.dataset.src; video.load(); } };
  const videoLabel = () => { videoButton.textContent = video.paused ? 'Play demo' : 'Pause demo'; videoButton.setAttribute('aria-label', video.paused ? 'Play product demonstration' : 'Pause product demonstration'); };
  const playVideo = () => { loadVideo(); video.play().catch(() => videoLabel()); };
  const syncVideo = () => {
    if (!videoInView || document.hidden || reduceMotion.matches || userPaused) { video.pause(); return; }
    playVideo();
  };
  if ('IntersectionObserver' in window) {
    const mediaObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
      videoInView = entry.isIntersecting;
      syncVideo();
    }), { threshold: 0.18 });
    mediaObserver.observe(video);
  }
  video.addEventListener('play', videoLabel);
  video.addEventListener('pause', videoLabel);
  video.addEventListener('error', () => { video.pause(); videoButton.textContent = 'Replay demo'; });
  videoButton.addEventListener('click', () => {
    if (video.paused) { userPaused = false; playVideo(); } else { userPaused = true; video.pause(); }
  });
  document.addEventListener('visibilitychange', syncVideo);
  reduceMotion.addEventListener?.('change', syncVideo);
  const dialog = page.querySelector('[data-pm-dialog]');
  const dialogImage = page.querySelector('[data-pm-dialog-image]');
  all('[data-pm-zoom]').forEach((button) => button.addEventListener('click', () => {
    const image = button.querySelector('img');
    dialogImage.src = image.currentSrc || image.src;
    dialogImage.alt = image.alt;
    if (typeof dialog.showModal === 'function') dialog.showModal(); else window.open(image.src, '_blank', 'noopener');
  }));
  page.querySelector('[data-pm-dialog-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  chooseVariant(selected.id, false);
  refreshSticky();
  videoLabel();
})();
